import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';
import { Title } from 'library';
import Toggle from './Toggle/Toggle';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isImperialSystem: props.isImperialSystem,
        }
    }

    systemChange(system) {
        this.setState({isImperialSystem: system}, ()=>{
            this.props.updateSystem(this.state.isImperialSystem);
        });
    }

    render() {
        const { image, title, description, metricLabel, imperialLabel, unitSystemToggle } = this.props;
        return (
            <div className={css(styles.header)}>
                {image &&
                <figure className={css(styles.figure)}>
                    <img className={css(styles.image)} src={image} alt="header" />
                </figure>
                }
                {title &&
                <Title style={styles.title}>{title}</Title>
                }
                <div className={css(styles.row)}>
                    {description &&
                    <div className={css(styles.stretchCol)}>
                        <div className={css(styles.description)} dangerouslySetInnerHTML={{__html: description}}></div>
                    </div>
                    }
                    {unitSystemToggle &&
                        <div className={css(styles.staticCol)}>
                            <Toggle
                                metricLabel={metricLabel}
                                imperialLabel={imperialLabel}
                                isImperialSystem={this.state.isImperialSystem}
                                onSystemChange={(system)=>this.systemChange(system)}
                            />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Header;